import { MapSection } from '../../components/overview';
import { BlockInfoIcon, Card } from '../../components/ui';
import { getOverviewBlockSubtitle, getOverviewBlockTitle } from '../../content';
import { useFilter } from '../../contexts/FilterContext';
import { writeRouteToWindow } from '../../routing';
import type { MapPropertyTooltipData } from '../../components/maps/WorldMap';
import type { LocationData } from './types';

interface OverviewMapSectionProps {
  locations: LocationData[];
}

export function OverviewMapSection({ locations }: OverviewMapSectionProps) {
  const { clientUnits, setUnit } = useFilter();

  const handlePropertyViewDetails = (property: MapPropertyTooltipData) => {
    const clientUnit = clientUnits.find((unit) => unit.unit_id_no === property.unitId);
    if (!clientUnit) return;

    setUnit(clientUnit);
    writeRouteToWindow('unit-overview');
  };

  return (
    <Card padding="flush" className="overview-map-card">
      <header className="overview-map-card__header">
        <div className="overview-panel-card__title-row">
          <h2 className="overview-panel-card__title">
            {getOverviewBlockTitle('portfolioMap', 'Portfolio Footprint')}
          </h2>
          <BlockInfoIcon blockId="portfolioMap" />
        </div>
        <p className="overview-panel-card__subtitle">
          {getOverviewBlockSubtitle('portfolioMap', 'Global asset distribution')}
        </p>
      </header>
      <MapSection
        locations={locations}
        onPropertyViewDetails={handlePropertyViewDetails}
      />
    </Card>
  );
}
